(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/first-page/components/svs-suspension-login.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/first-page/components/svs-suspension-login.js');
'use strict';

const {
  ReactButton: Button
} = svs.ui;
const {
  baseUrl
} = svs.core.data;
const {
  ROUTE
} = svs.spelpaus.constants;
const SvsSuspensionLogin = () => {
  const loginUrl = "".concat(baseUrl).concat(ROUTE.svsSuspension);
  return React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "h1 align-left"
  }, "Spelpaus Svenska Spel"), React.createElement("div", {
    className: "align-left"
  }, "P\xE5 www.svenskaspel.se/tur kan du pausa dig fr\xE5n spel i 24 timmar, 3 m\xE5nader, 6 m\xE5nader, 1 \xE5r och 3 \xE5r. F\xF6r att g\xF6ra detta beh\xF6ver du logga in."), React.createElement("a", {
    className: "u-text-reset",
    href: loginUrl
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    inverted: true,
    size: 300
  }, "Logga in")));
};
svs.spelpaus.pages.firstPage.components.SvsSuspensionLogin = SvsSuspensionLogin;

 })(window);